/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { ErrorMessage } from "formik";
import { Select, Tooltip } from "antd";
import { MdErrorOutline } from "react-icons/md";
import { IoIosAddCircleOutline } from "react-icons/io";
import { FiInfo } from "react-icons/fi";

const CustomDropDownInput = ({
  title,
  name,
  placeholder,
  requiredField = false,
  errors,
  options = [],
  values,
  touched,
  displayLabel,
  idLabel = "id",
  setFieldValue,
  showSearch = false,
  setStreams = null,
  add = false,
  addStep,
  mode = false,
  makeChange = false,
  disabled = false,
  tip = false,
}) => {
  const handleChange = async (e) => {
    if (makeChange) {
      makeChange(e);
    } else {
      setFieldValue(name, e);
      if (name === "class_id" && options.length > 0) {
        const filteredClass = options.find((class1) => class1.id === +e);
        if (filteredClass) {
          setStreams(filteredClass.streams);
        }
      }
    }
  };

  return (
    <div className="mb-3 w-full">
      <div className="flex gap-3 items-center justify-between">
        <label
          htmlFor={name}
          className="block leading-6 text-gray-500 mb-2 text-sm"
        >
          {title}
          {requiredField && <span className="text-red-800 mx-1">*</span>}
        </label>
        {tip && (
          <Tooltip title={tip} className="text-gray-400">
            <FiInfo size={14} />
          </Tooltip>
        )}
      </div>
      <div className="flex items-end">
        <Select
          mode={mode}
          showSearch={showSearch}
          id={name}
          defaultValue={""}
          value={values[name] || ""}
          disabled={disabled}
          className={`w-full custom-select ${
            disabled
              ? "cursor-not-allowed text-gray-100 bg-gray-100"
              : "bg-transparent"
          }`}
          style={{
            height: "36px",
            border:
              errors && errors[name] && touched && touched[name]
                ? "1px solid red"
                : "",
            borderRadius: "0px",
            width: "100%",
          }}
          onChange={handleChange}
          filterOption={(input, option) =>
            option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          <Select.Option value={""}>{placeholder}</Select.Option>
          {options.map((option, index) => (
            <Select.Option
              key={index}
              value={option[idLabel]}
              disabled={option.disabled}
            >
              {option[displayLabel]}
            </Select.Option>
          ))}
        </Select>

        {add && addStep && (
          <div
            className="flex gap-1 items-center text-xs mt-1 text-sky-600 cursor-pointer text-right w-10 justify-center h-[36px]"
            onClick={addStep}
          >
            <IoIosAddCircleOutline size={24} />
          </div>
        )}
      </div>

      <ErrorMessage name={name}>
        {(msg) => (
          <div className="text-xs text-red-500 text-left w-full flex gap-1 items-center mt-1">
            <MdErrorOutline size={16} />
            <p className="text-xs">{msg}</p>
          </div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default CustomDropDownInput;
